import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { FormField, ResultCard } from '../finance/shared';

const DayCountCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [startDate, setStartDate] = useState('2024-01-01');
  const [endDate, setEndDate] = useState('2024-12-31');
  const [res, setRes] = useState<number | null>(null);

  const calculate = () => {
    if (!startDate || !endDate) return;
    const s = new Date(startDate);
    const e = new Date(endDate);
    const diff = Math.ceil(Math.abs(e.getTime() - s.getTime()) / (1000 * 60 * 60 * 24));
    setRes(diff);
    onResultChange([{ label: 'Dias Totais', value: diff.toString() }]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <FormField label="Data Inicial" value={startDate} onChange={setStartDate} type="date" required />
          <FormField label="Data Final" value={endDate} onChange={setEndDate} type="date" required />
        </div>
        <div className="flex justify-center mb-8">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold shadow-accent hover:scale-105 transition-all">Calcular</button>
        </div>
        {res !== null && <ResultCard title="Total de Dias" value={res} color="indigo" />}
      </div>
    </div>
  );
};

export default DayCountCalculator;
